import { BUSINESS_OFFERS } from '@sravni/ugc/lib/specialOffers/lists';
import type { BusinessOffersType } from '@sravni/ugc/lib/specialOffers/types';

import { getAccountingConditions } from '../../helpers/conditions/business/accounting';
import { getBankovskieGarantiiConditions } from '../../helpers/conditions/business/bankovskieGarantii';
import { getBiznesCreditConditions } from '../../helpers/conditions/business/biznesCredit';
import { getBiznesVedConditions } from '../../helpers/conditions/business/biznesVed';
import { getBusinessRegistrationConditions } from '../../helpers/conditions/business/businessRegistration';
import { getEkvajringConditions } from '../../helpers/conditions/business/ekvajring';
import { getLeasingConditions } from '../../helpers/conditions/business/leasing';
import { getMarketplaceConditions } from '../../helpers/conditions/business/marketplace';
import { getRKOConditions } from '../../helpers/conditions/business/rko';
import { getZarplatnyjProektConditions } from '../../helpers/conditions/business/zarplatnyjProekt';
import type { OfferTab } from '../../helpers/getProductData';

export const businessProductsInfo: Record<BusinessOffersType, OfferTab> = {
  [BUSINESS_OFFERS.biznesRegistration]: {
    key: { type: BUSINESS_OFFERS.biznesRegistration },
    label: '',
    generalLink: '/biznes-registration/',
    linkToOneProduct: null,
    getConditions: getBusinessRegistrationConditions,
    advertisingCategory: 'Регистрация бизнеса',
  },
  [BUSINESS_OFFERS.biznesRko]: {
    key: { type: BUSINESS_OFFERS.biznesRko },
    label: '',
    generalLink: '/rko/',
    linkToOneProduct: '',
    getConditions: getRKOConditions,
    advertisingCategory: 'РКО',
  },
  [BUSINESS_OFFERS.biznesKredity]: {
    key: { type: BUSINESS_OFFERS.biznesKredity },
    label: 'кредит',
    generalLink: '/biznes-kredity/',
    linkToOneProduct: '',
    getConditions: getBiznesCreditConditions,
    advertisingCategory: 'Бизнес-кредиты',
  },
  [BUSINESS_OFFERS.biznesAccounting]: {
    key: { type: BUSINESS_OFFERS.biznesAccounting },
    label: '',
    generalLink: '/biznes-accounting/',
    linkToOneProduct: '',
    getConditions: getAccountingConditions,
    advertisingCategory: 'Бухгалтерия для бизнеса',
  },
  [BUSINESS_OFFERS.bankovskieGarantii]: {
    key: { type: BUSINESS_OFFERS.bankovskieGarantii },
    label: '',
    generalLink: '/biznes/bankovskie-garantii/',
    linkToOneProduct: '',
    getConditions: getBankovskieGarantiiConditions,
    advertisingCategory: 'Банковские гарантии',
  },
  [BUSINESS_OFFERS.biznesEkvajring]: {
    key: { type: BUSINESS_OFFERS.biznesEkvajring },
    label: '',
    generalLink: '/biznes/ekvajring/',
    linkToOneProduct: '',
    getConditions: getEkvajringConditions,
    advertisingCategory: 'Эквайринг',
  },
  [BUSINESS_OFFERS.biznesMarketplace]: {
    key: { type: BUSINESS_OFFERS.biznesMarketplace },
    label: '',
    generalLink: '/biznes-marketplace/',
    linkToOneProduct: '',
    getConditions: getMarketplaceConditions,
    advertisingCategory: 'Бизнес на маркетплейс',
  },
  [BUSINESS_OFFERS.biznesLeasing]: {
    key: { type: BUSINESS_OFFERS.biznesLeasing },
    label: '',
    generalLink: '/biznes-leasing/',
    linkToOneProduct: '',
    getConditions: getLeasingConditions,
    advertisingCategory: 'Лизинг',
  },
  [BUSINESS_OFFERS.biznesVed]: {
    key: { type: BUSINESS_OFFERS.biznesVed },
    label: '',
    generalLink: '/biznes-ved/',
    linkToOneProduct: '',
    getConditions: getBiznesVedConditions,
    advertisingCategory: 'ВЭД',
  },
  [BUSINESS_OFFERS.zarplatnyjProekt]: {
    key: { type: BUSINESS_OFFERS.zarplatnyjProekt },
    label: '',
    generalLink: '/biznes/zarplatnyj-proekt/',
    linkToOneProduct: '',
    getConditions: getZarplatnyjProektConditions,
    advertisingCategory: 'Зарплатный проект',
  },
};
